"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * pollination-server
 * Pollination Server OpenAPI Definition
 *
 * The version of the OpenAPI document: 1.1.1
 * Contact: info@pollination.cloud
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const base_1 = require("../base");
/**
 * SubscriptionsApi - axios parameter creator
 * @export
 */
const SubscriptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Cancel a subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: (subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling cancelSubscription.');
            }
            const localVarPath = `/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Subscribe account to subscritpion plan
         * @param {SubscriptionCreate} subscriptionCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: (subscriptionCreate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionCreate' is not null or undefined
            if (subscriptionCreate === null || subscriptionCreate === undefined) {
                throw new base_1.RequiredError('subscriptionCreate', 'Required parameter subscriptionCreate was null or undefined when calling createSubscription.');
            }
            const localVarPath = `/subscriptions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof subscriptionCreate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(subscriptionCreate !== undefined ? subscriptionCreate : {}) : (subscriptionCreate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve a subscription by ID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: (subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling getSubscription.');
            }
            const localVarPath = `/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Subscriptions
         * @param {string} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPollinationSubscriptions: (account, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/subscriptions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (account !== undefined) {
                localVarQueryParameter['account'] = account;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List Payment for a Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPayments: (subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling listSubscriptionPayments.');
            }
            const localVarPath = `/subscriptions/{subscription_id}/payments`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary List the quotas for a given subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionQuotas: (subscriptionId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling listSubscriptionQuotas.');
            }
            const localVarPath = `/subscriptions/{subscription_id}/quotas`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a subscription
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: (subscriptionId, subscriptionUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling updateSubscription.');
            }
            // verify required parameter 'subscriptionUpdate' is not null or undefined
            if (subscriptionUpdate === null || subscriptionUpdate === undefined) {
                throw new base_1.RequiredError('subscriptionUpdate', 'Required parameter subscriptionUpdate was null or undefined when calling updateSubscription.');
            }
            const localVarPath = `/subscriptions/{subscription_id}`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof subscriptionUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(subscriptionUpdate !== undefined ? subscriptionUpdate : {}) : (subscriptionUpdate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Preview the effect of a subscription update
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreivew: (subscriptionId, subscriptionUpdate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'subscriptionId' is not null or undefined
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new base_1.RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling updateSubscriptionPreivew.');
            }
            // verify required parameter 'subscriptionUpdate' is not null or undefined
            if (subscriptionUpdate === null || subscriptionUpdate === undefined) {
                throw new base_1.RequiredError('subscriptionUpdate', 'Required parameter subscriptionUpdate was null or undefined when calling updateSubscriptionPreivew.');
            }
            const localVarPath = `/subscriptions/{subscription_id}/preview`
                .replace(`{${"subscription_id"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication APIKeyAuth required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? yield configuration.apiKey("x-pollination-token")
                    : yield configuration.apiKey;
                localVarHeaderParameter["x-pollination-token"] = localVarApiKeyValue;
            }
            // authentication JWTAuth required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? yield configuration.accessToken()
                    : yield configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            const needsSerialization = (typeof subscriptionUpdate !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(subscriptionUpdate !== undefined ? subscriptionUpdate : {}) : (subscriptionUpdate || "");
            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SubscriptionsApiAxiosParamCreator = SubscriptionsApiAxiosParamCreator;
/**
 * SubscriptionsApi - functional programming interface
 * @export
 */
const SubscriptionsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Cancel a subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).cancelSubscription(subscriptionId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Subscribe account to subscritpion plan
         * @param {SubscriptionCreate} subscriptionCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(subscriptionCreate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).createSubscription(subscriptionCreate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Retrieve a subscription by ID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).getSubscription(subscriptionId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary List Subscriptions
         * @param {string} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPollinationSubscriptions(account, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).listPollinationSubscriptions(account, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary List Payment for a Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPayments(subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).listSubscriptionPayments(subscriptionId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary List the quotas for a given subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionQuotas(subscriptionId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).listSubscriptionQuotas(subscriptionId, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Update a subscription
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId, subscriptionUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).updateSubscription(subscriptionId, subscriptionUpdate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
        /**
         *
         * @summary Preview the effect of a subscription update
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreivew(subscriptionId, subscriptionUpdate, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield (0, exports.SubscriptionsApiAxiosParamCreator)(configuration).updateSubscriptionPreivew(subscriptionId, subscriptionUpdate, options);
                return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                    const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                    return axios.request(axiosRequestArgs);
                };
            });
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
/**
 * SubscriptionsApi - factory interface
 * @export
 */
const SubscriptionsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Cancel a subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).cancelSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Subscribe account to subscritpion plan
         * @param {SubscriptionCreate} subscriptionCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription(subscriptionCreate, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).createSubscription(subscriptionCreate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve a subscription by ID
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription(subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).getSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Subscriptions
         * @param {string} [account]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPollinationSubscriptions(account, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).listPollinationSubscriptions(account, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List Payment for a Subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionPayments(subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).listSubscriptionPayments(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary List the quotas for a given subscription
         * @param {string} subscriptionId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptionQuotas(subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).listSubscriptionQuotas(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a subscription
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(subscriptionId, subscriptionUpdate, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).updateSubscription(subscriptionId, subscriptionUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Preview the effect of a subscription update
         * @param {string} subscriptionId
         * @param {SubscriptionUpdate} subscriptionUpdate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionPreivew(subscriptionId, subscriptionUpdate, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).updateSubscriptionPreivew(subscriptionId, subscriptionUpdate, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
/**
 * SubscriptionsApi - object-oriented interface
 * @export
 * @class SubscriptionsApi
 * @extends {BaseAPI}
 */
class SubscriptionsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Cancel a subscription
     * @param {SubscriptionsApiCancelSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    cancelSubscription(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).cancelSubscription(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Subscribe account to subscritpion plan
     * @param {SubscriptionsApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    createSubscription(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).createSubscription(requestParameters.subscriptionCreate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve a subscription by ID
     * @param {SubscriptionsApiGetSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    getSubscription(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).getSubscription(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Subscriptions
     * @param {SubscriptionsApiListPollinationSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    listPollinationSubscriptions(requestParameters = {}, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).listPollinationSubscriptions(requestParameters.account, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List Payment for a Subscription
     * @param {SubscriptionsApiListSubscriptionPaymentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    listSubscriptionPayments(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).listSubscriptionPayments(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary List the quotas for a given subscription
     * @param {SubscriptionsApiListSubscriptionQuotasRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    listSubscriptionQuotas(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).listSubscriptionQuotas(requestParameters.subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a subscription
     * @param {SubscriptionsApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    updateSubscription(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).updateSubscription(requestParameters.subscriptionId, requestParameters.subscriptionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Preview the effect of a subscription update
     * @param {SubscriptionsApiUpdateSubscriptionPreivewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionsApi
     */
    updateSubscriptionPreivew(requestParameters, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).updateSubscriptionPreivew(requestParameters.subscriptionId, requestParameters.subscriptionUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SubscriptionsApi = SubscriptionsApi;
